import React, {useState } from "react"
import { withTranslation } from 'react-i18next'
import { Col, Row } from '@amzn/stencil-react-components/layout'
import { H2 } from '@amzn/stencil-react-components/text'
import QASections from './QASections';
import { ToggleButton } from '@amzn/stencil-react-components/toggle-button';

const Faqs=({t,faqs})=> {

    if (faqs.length == 0) {
      return null;
    }
    const [allExpanded, setAllExpanded] = useState(false);
    return (
      <Col dataTestId="faq-container" gridGap="S300">
        <Row
          justifyContent="space-between"
        >
          <H2>{t("HelpfulInformation.FAQTitle")}</H2>
          <ToggleButton
            dataTestId="faq-answer-expand-all"
            isSelected={allExpanded}
            onClick={() => setAllExpanded(!allExpanded)}>
            {allExpanded? t("HelpfulInformation.FAQExpandButton.CollapseAll") : t("HelpfulInformation.FAQExpandButton.ExpandAll")}
          </ToggleButton>
        </Row>
        <Col gridGap="S300">
          {faqs.map((faq, index) =>(
              <QASections key={index} faq={faq} index={index} isAllExpanded={allExpanded}/>
          ))}
        </Col>
      </Col>
    );
}

export default withTranslation('translationsV2')(Faqs)
